import React, { useMemo } from "react";

// A deterministic starfield rendered purely with CSS dots + a faint texture overlay.
export const StarfieldBackground = () => {
  const stars = useMemo(() => {
    const arr = [];
    for (let i = 0; i < 70; i++) {
      arr.push({
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 2 + 1,
        delay: Math.random() * 5,
        dur: 3 + Math.random() * 4,
      });
    }
    return arr;
  }, []);

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-[#0B0C15]" aria-hidden="true">
      <div
        className="absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1622793139910-e261be0b30a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbmlnaHQlMjBza3klMjBzdGFycyUyMHRleHR1cmV8ZW58MHx8fHwxNzg3OTYzNzcwfDA&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div
        className="absolute -top-40 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full opacity-30 blur-[120px]"
        style={{ background: "radial-gradient(circle, #722F37 0%, transparent 70%)" }}
      />
      <div
        className="absolute bottom-[-10rem] right-[-6rem] h-[420px] w-[420px] rounded-full opacity-20 blur-[120px]"
        style={{ background: "radial-gradient(circle, #D9A441 0%, transparent 70%)" }}
      />
      {stars.map((s, i) => (
        <span
          key={i}
          className="absolute rounded-full bg-[#F8F3E6]"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animation: `twinkle ${s.dur}s ease-in-out ${s.delay}s infinite`,
          }}
        />
      ))}
    </div>
  );
};
